import { render, staticRenderFns } from "./TagAttacher.vue?vue&type=template&id=2b67c263&"
import script from "./TagAttacher.vue?vue&type=script&lang=js&"
export * from "./TagAttacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports